import React from 'react';

export default function Header() {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="header-brand">
          <div className="header-logo">EPG</div>
          <div className="header-text">
            <div className="header-title">Escuela de Posgrado</div>
            <div className="header-subtitle">Universidad Nacional de San Martín – Tarapoto</div>
          </div>
        </div>
      </div>
    </header>
  );
}
